import React from 'react';
import Image from 'next/legacy/image';

import { IPagePointerFields } from '../../../types/contentful';

import Link from '../Link';

import rightArrowIcon from '@/images/right-arrow-icon.svg';

export function PagePointer({ title, url }: IPagePointerFields) {
  return (
    <div className="flex items-center justify-between border-b border-[#D0D0D0] px-0 py-5 tablet:px-0 tablet:py-8">
      <h3
        className="text-[22px] font-medium desktop:text-[26px]"
        data-testid="page-pointer-header"
      >
        <Link href={url} style={{ textDecoration: 'none', color: '#000' }}>
          {title}
        </Link>
      </h3>
      <div className="pl-2 pt-0.5 tablet:pl-4 tablet:pt-1">
        <button className="bg-transparent m-0 cursor-pointer appearance-none border-0 p-0">
          <div className="p-1">
            <Link href={url}>
              <div className="size-[15px]">
                <Image src={rightArrowIcon} alt="" />
              </div>
            </Link>
          </div>
        </button>
      </div>
    </div>
  );
}
